import { Injectable } from '@angular/core';
import API, { graphqlOperation } from '@aws-amplify/api';
import { PCGFilterInput } from 'app/api/API.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface PCGEntry {
  id: string;
  label: string;
}

export interface PCGConnection {
  items: PCGEntry[];
  lastEvaluatedKey: any;
}

@Injectable({
  providedIn: 'root'
})
export class PCGAPIService {
  Pcg(
    account?: string,
    filter?: PCGFilterInput,
    limit?: number,
    exclusiveStartKey?: string
  ): Observable<PCGConnection> {
    const statement = `query Pcg($account: String, $filter: PCGFilterInput, $limit: Int, $exclusiveStartKey: AWSJSON) {
        pcg(account: $account, filter: $filter, limit: $limit, exclusiveStartKey: $exclusiveStartKey) {
          items {
            id
            label
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (account) {
      gqlAPIServiceArguments.account = account;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (exclusiveStartKey) {
      gqlAPIServiceArguments.exclusiveStartKey = exclusiveStartKey;
    }
    return from(API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )).pipe(
      map((response: any) => response.data.pcg as PCGConnection)
    );
  }  
}
